import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import RetreatBackUpApi from "../../../api/retreatBackUpApi";
import AuthApi from "../../../api/authApi";
import { toast } from "react-toastify";
import CustomDataTable from "../../../components/CustomDataTable";
import Helpers from "../../../components/Helpers";
import DeleteModel from "../../../components/DeleteModel";
import { Cookies } from "react-cookie";
import "react-datepicker/dist/react-datepicker.css";
import RetreatApi from "../../../api/retreatApi";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import moment from "moment";
import AlertModal from "../../../components/AlertModel";
import "../../../assets/css/ManageRetreatModern.css";

const RetreatBackUp = () => {
  const [total, setTotal] = useState(20);
  const [searchKey, setSearchKey] = useState("");
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  let cookies = new Cookies();
  let userData = cookies.get("LoveStrongUser") || null;
  const [LoadData, setLoadData] = useState(false);
  const [retreatDetail, setRetreatDetail] = useState([]);
  const [deleteList, setDeleteList] = useState(null);
  let retreatBackUpApi = new RetreatBackUpApi();
  let retreatApi = new RetreatApi();
  let navigate = useNavigate();

  useEffect(() => {
    getBackUpRetreats();
  }, []);

  const getBackUpRetreats = async (
    pageNo = 1,
    size = 20,
    searchKeyword = null,
    sortBy = {},
    loadCount = false,
    coupleId,
  ) => {
    setDeleteList([]);
    setLoadData(true);
    let d = {};
    if (pageNo && size) {
      d.pageNo = pageNo;
      d.size = size;
    }
    if (searchKeyword !== null) {
      d.searchKeyword = searchKeyword;
    } else {
      d.searchKeyword = searchKey;
    }
    if (sortBy.sortColumn) {
      d.sortBy = sortBy;
    }
    d.export = false;
    d.coupleId = coupleId;
    await retreatBackUpApi
      .getBackUpRetreats(d)
      .then((res) => {
        if (res.success) {
          let totalRecords = res.totalRecords ? res.totalRecords : 0;
          setTotal(totalRecords);
          const parsedData = res.data.map((item) => {
            const { schedule, ...rest } = item;
            const parsedSchedule = schedule ? JSON.parse(schedule) : [];
            return {
              ...rest,
              schedule: parsedSchedule.map((entry) => ({
                date: new Date(entry.date),
                from: entry.from,
                to: entry.to,
              })),
            };
          });
          setLoadData(false);
          setDeleteList(parsedData);
        } else {
          setLoadData(false);
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        setLoadData(false);
        toast.error(error);
      });
  };

  console.log("retreatDetail---->", retreatDetail);

  const restoreRetreat = async () => {
    await retreatBackUpApi
      .restoreRetreat({ id: retreatDetail.id })
      .then(async (res) => {
        if (res.success) {

          toast.success(res.msg);
          getBackUpRetreats();
          setRetreatDetail([]);
          setShow1(false);
        } else {
          toast.error(res.msg);
          getBackUpRetreats();
          setRetreatDetail([]);
          setShow1(false);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const permanentDeleteRetreat = async () => {
    await retreatBackUpApi
      .permanentDeleteRetreat({ id: retreatDetail.id })
      .then(async (res) => {
        if (res.success) {
          toast.success(res.msg);
          getBackUpRetreats();
          setShow(false);

        } else {
          toast.error(res.msg);
          getBackUpRetreats();
          setShow(false);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const SearchData = (event) => {
    const key = event.target.value;
    if (key !== "") {
      setSearchKey(event.target.value);
      getBackUpRetreats(1, 20, event.target.value);
    } else {
      setSearchKey("");
      getBackUpRetreats(1, 20, event.target.value);
    }
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip">{props}</Tooltip>
  );

  const columns = [
    {
      id: "title",
      name: "Retreat Title",
      selector: (row) => {
        const displayDate =
          row.dateFrom === row.dateTo
            ? moment(row && row.dateFrom).format("MMM-DD-YYYY")
            : moment(row && row.dateFrom).format("MMM-DD") +
              " - " +
              moment(row.dateTo).format("MMM DD") +
              ", " +
              moment(row && row.dateFrom).format("YYYY");
        return (
          <>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              popperConfig={{ strategy: "fixed" }}
              overlay={renderTooltip(row.title || "Retreat")}
            >
              <a
                href=""
                className="mr-retreat-link"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`/retreatRoster?retreatId=${row.id}`);
                }}
              >
                <div className="mr-retreat-name">{row.title}</div>
              </a>
            </OverlayTrigger>
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip(displayDate)}
            >
              <span className="mr-retreat-date">{displayDate}</span>
            </OverlayTrigger>
          </>
        );
      },
      sortable: true,
      reorder: true,
      grow: 0,
      width: "220px",
    },
    {
      id: "language",
      name: "Language",
      selector: (row) =>
        row.language.charAt(0).toUpperCase() + row.language.slice(1),
      sortable: true,
      reorder: true,
      grow: 0,
      width: "100px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "location",
      name: "Location",
      selector: (row) =>
        row.location.charAt(0).toUpperCase() + row.location.slice(1),
      sortable: true,
      reorder: true,
      grow: 0,
      width: "110px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "fromToDate",
      name: "Retreat Dates",
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            row.dateFrom === row.dateTo
              ? moment(row && row.dateFrom).format("MMM-DD-YYYY")
              : moment(row && row.dateFrom).format("MMM DD") +
                  " - " +
                  moment(row && row.dateTo).format("MMM DD") +
                  ", " +
                  moment(row && row.dateFrom).format("YYYY"),
          )}
        >
          {row.dateFrom === row.dateTo ? (
            <span>{moment(row && row.dateFrom).format("MMM-DD-YYYY")}</span>
          ) : (
            <span>
              {moment(row && row.dateFrom).format("MMM-DD") +
                " - " +
                moment(row.dateTo).format("MMM DD") +
                ", " +
                moment(row && row.dateFrom).format("YYYY")}
            </span>
          )}
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      grow: 0,
      width: "120px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "team",
      name: "# Team Couples",
      selector: (row) => row && row.countTeam,
      cell: (row) => (
        <div className="tooltip-static-demo">
          <div
            className="bs-tooltip-bottom bs-tooltip-bottom-demo tooltip-info"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title=""
            data-bs-original-title="Decorations, Facilities, Go Team, Kitchen"
          >
            <div className="arrow"></div>
            <a
              href={`/retreatRoster?retreatId=${row.id}&flag=2`}
              style={{ textDecoration: "none" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="tooltip-inner">{row && row.countTeam}</div>
            </a>
          </div>
        </div>
      ),
      reorder: true,
      sortable: true,
      grow: 0,
      width: "110px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Retreatants",
      name: "# Retreatant Couples",
      selector: (row) => row && row.countRetreatant,
      cell: (row) => (
        <div className="tooltip-static-demo">
          <div
            className="bs-tooltip-bottom bs-tooltip-bottom-demo tooltip-info"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title=""
            data-bs-original-title="Decorations, Facilities, Go Team, Kitchen"
          >
            <div className="arrow"></div>
            <a
              href={`/retreatRoster?retreatId=${row.id}&flag=1`}
              style={{ textDecoration: "none" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="tooltip-inner">{row && row.countRetreatant}</div>
            </a>
          </div>
        </div>
      ),
      reorder: true,
      sortable: true,
      grow: 0,
      width: "130px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Directory",
      name: "Directory",
      button: true,
      cell: (row) => (
        <a
          href={`/create-directory/${row.id}`}
          className="action-icons"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="mdi mdi-file-document-box" title="View directory"></i>
        </a>
      ),
      reorder: true,
      grow: 0,
      width: "90px",
    },
    {
      id: "Program",
      name: "Program",
      button: true,
      cell: (row) => (
        <a
          href={`/create-program/${row.id}`}
          className="action-icons"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="mdi mdi-format-list-bulleted" title="View program"></i>
        </a>
      ),
      reorder: true,
      grow: 0,
      width: "90px",
    },
    {
      id: "created",
      name: "Created",
      selector: (row) =>
        Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY"),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY hh:mm:a"),
          )}
        >
          <span>
            {Helpers.convertUtcToTimezone(row && row.createdAt, "MM-DD-YYYY")}
          </span>
        </OverlayTrigger>
      ),
      reorder: true,
      sortable: true,
      grow: 0,
      width: "110px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Deleted Date",
      name: "Deleted Date",
      selector: (row) =>
        Helpers.convertUtcToTimezone(row.updatedAt, "MM-DD-YYYY"),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.updatedAt, "MM-DD-YYYY hh:mm:a"),
          )}
        >
          <span>
            {Helpers.convertUtcToTimezone(row && row.updatedAt, "MM-DD-YYYY")}
          </span>
        </OverlayTrigger>
      ),
      reorder: true,
      sortable: true,
      grow: 0,
      width: "118px",
      style: {
        cursor: "text",
      },
    },
    ...(userData && userData.userRole === "ADMIN"
      ? [
          {
            id: "action",
            name: "Action",
            button: true,
            cell: (row) => (
              <>
                <Link
                  to={`/create-retreat/${row.id}`}
                  className="font-size action-icons"
                >
                  <i
                    className="mdi mdi-pencil-box text-lg editRetreatButton font-size"
                    title="Edit"
                  ></i>
                </Link>
                <button
                  className="font-size action-icons"
                  onClick={() => handleShow(row)}
                >
                  <i
                    className="mdi mdi-delete-forever text-md deleteRetreatButton font-size"
                    title="Permanent Delete"
                  ></i>
                </button>
                <button
                  className="font-size action-icons"
                  onClick={() => handleShow1(row)}
                >
                  <i
                    className="mdi mdi-backup-restore text-md restoreRetreatButton font-size"
                    title="Restore"
                  ></i>
                </button>
                <a
                  href={`/registration-retreat/${row.id}?backup=true`}
                  className="font-size action-icons"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="mdi mdi-eye" title="View"></i>
                </a>
              </>
            ),
            reorder: true,
            grow: 0,
            width: "188px",
          },
        ]
      : []),
  ];

  const handleShow = (item) => {
    setRetreatDetail(item);
    setShow(true);
  };

  const handleClose = () => {
    getBackUpRetreats();
    setShow(false);
    setRetreatDetail([]);
  };

  const handleShow1 = (item) => {
    setRetreatDetail(item);
    setShow1(true);
  };

  const handleClose1 = () => {
    getBackUpRetreats();
    setRetreatDetail([]);
    setShow1(false);
  };

  const isAdmin = userData && userData.userRole === "ADMIN";

  return (
    <div className="mr-page mr-page-backup">
      <header className="mr-header">
        <div className="mr-header-copy">
          <p className="mr-kicker">Retreat management</p>
          <div className="mr-title-row">
            <h1 className="mr-title">Retreat Backups</h1>
            <span className="mr-count">{total || 0}</span>
          </div>
        </div>
        <div className="mr-header-actions">
          <Link to="/manageRetreat" className="mr-btn mr-btn-ghost">
            Manage retreats
          </Link>
          {isAdmin ? (
            <Link to="/create-retreat" className="mr-btn mr-btn-primary">
              <i className="mdi mdi-plus" />
              Add Retreat
            </Link>
          ) : null}
        </div>
      </header>

      {isAdmin ? (
        <div className="mr-toolbar">
          <label className="mr-field mr-field-search mr-field-search-fixed">
            <i className="mdi mdi-magnify" aria-hidden="true" />
            <input
              onChange={SearchData}
              value={searchKey}
              type="search"
              placeholder="Search parish, language, or location"
              aria-label="Search retreat backups"
            />
          </label>
        </div>
      ) : null}

      <section className="mr-table-card" aria-label="Retreat Backups">
        <CustomDataTable
          loading={LoadData}
          data={deleteList || []}
          countPerPage={20}
          isServerSide={true}
          pagination={true}
          sortServer={true}
          total={total}
          columns={columns}
          dataFetchApi={getBackUpRetreats}
          pointerOnHover={true}
          highlightOnHover={true}
          noDataComponent={
            <div className="mr-empty">
              <p>No backup retreats to show</p>
              <span>Deleted retreats will appear here.</span>
            </div>
          }
        />
      </section>
        {show ? (
          <DeleteModel
            show={show}
            handleClose={handleClose}
            DeleteData={permanentDeleteRetreat}
            title={retreatDetail.title}
            selectionDelete="permanent"
          ></DeleteModel>
        ) : null}
        {show1 ? (
          <AlertModal
            show={show1}
            handleClose={handleClose1}
            message={`<h5 className="mt-2 deleteMessage">
                Are you sure to restore this Retreat?
                <h4 className="mt-3">
                  <b>${retreatDetail ? retreatDetail.title : ""}</b>
                </h4>
              </h5>`}
            actionFunction={restoreRetreat}
            cancel={"Cancel"}
            okay={"Okay"}
            heading={"ALERT!!"}
          />
        ) : null}
    </div>
  );
};
export default RetreatBackUp;
